// index.tsx
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  PublicClientApplication,
  EventType,
  AccountInfo,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { itsConfig } from 'http/authConfig';

import './index.css';
import { LinearProgress } from '@mui/material';
import './languages/i18n';
import App from 'App';

// MSAL setup (BEHOLD ALT DETTE SOM DU HAR)
export const msalInstance = new PublicClientApplication(itsConfig);
const LAST_ACCOUNT_KEY = 'bluu:lastAccountId';

const cachedAccounts = msalInstance.getAllAccounts();
const lastAccountId = localStorage.getItem(LAST_ACCOUNT_KEY);
if (!msalInstance.getActiveAccount() && cachedAccounts.length > 0) {
  const preferredAccount =
    (lastAccountId &&
      cachedAccounts.find(
        (account) => account.homeAccountId === lastAccountId
      )) ||
    cachedAccounts[0];
  console.log('KKK: Setting active account', {
    lastAccountId: lastAccountId,
    cachedAccounts: cachedAccounts,
    LAST_ACCOUNT_KEY: LAST_ACCOUNT_KEY,
    preferredAccount: preferredAccount,
    MSAL: msalInstance.getActiveAccount(),
  });

  msalInstance.setActiveAccount(preferredAccount);
  localStorage.setItem(LAST_ACCOUNT_KEY, preferredAccount.homeAccountId);
}

msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  console.log('KKK: addEventCallback', {
    event: event,
  });
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const account = (event.payload as { account: AccountInfo }).account;
    if (account) {
      msalInstance.setActiveAccount(account);
      localStorage.setItem(LAST_ACCOUNT_KEY, account.homeAccountId);
    }
  }

  if (event.eventType === EventType.LOGOUT_SUCCESS) {
    localStorage.removeItem(LAST_ACCOUNT_KEY);
  }
});

msalInstance.addEventCallback((event) => {
  switch (event.eventType) {
    case EventType.LOGIN_SUCCESS:
      console.log('Login success: ', event);
      break;
    case EventType.ACQUIRE_TOKEN_FAILURE:
      console.log('Acquire token failure: ', event);
      break;
    case EventType.SSO_SILENT_FAILURE:
      console.log('SSO silent failure: ', event);
      break;
    case EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE:
      console.log('Acquire token by code failure ', event);
      break;
    case EventType.LOGIN_FAILURE:
      console.log('Login failure ', event);
      break;
    default:
      break;
  }
});

const container = document.getElementById('root');
if (!container) throw new Error('root element ikke funnet');

const root = ReactDOM.createRoot(container);
console.log('KKK: Rendering app with MSAL instance', {
  msalInstance: msalInstance,
});
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Suspense fallback={<LinearProgress />}>
          <App pca={msalInstance} />
        </Suspense>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
